import { Box } from "@mui/material";
import ReminderCategoryCard from "./ReminderCategoryCard";
import { AdminPanelSettingsOutlined, EngineeringOutlined, ReduceCapacityOutlined } from "@mui/icons-material";
import { useMemo } from "react";
import { useRemindersQuery } from "../../hooks/useRemindersQuery";
import { EReminderProcessType, EReminderTargetEntity } from "../../enums/reminders.enums";
import { useRemindersMutation } from "../../hooks/useRemindersMutation";
import { filterRemindersByTarget } from "../../helpers/filter-reminders-by-type.helper";
import { CreateRemindersConfig } from "../../interfaces/create-reminder.interface";
import { UpdateReminderConfig } from "../../interfaces/update-reminder.interface";

export default function OrganizationReminders() {
  const { data: reminders } = useRemindersQuery();
  const { createReminderMutation, updateReminderMutation, deleteReminderMutation } = useRemindersMutation();

  const groupedReminders = useMemo(() => {
    const dataToFilter = Array.isArray(reminders) ? reminders : [];
    return filterRemindersByTarget(dataToFilter);
  }, [reminders]);

  const handleCreateReminder = (data: CreateRemindersConfig) => {
    createReminderMutation.mutate(data);
  };

  const handleUpdateReminder = (uid: string, data: Partial<UpdateReminderConfig>) => {
    updateReminderMutation.mutate({ uid, data });
  };

  const handleDeleteReminder = (uid: string) => {
    deleteReminderMutation.mutate(uid);
  };

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
        height: "100%",
        width: "100%",
        px: 8,
      }}
    >
      <ReminderCategoryCard
        reminders={groupedReminders.admins}
        title="Admins"
        icon={<AdminPanelSettingsOutlined />}
        processType={EReminderProcessType.OTHER}
        targetEntity={EReminderTargetEntity.COMPANY}
        onCreateReminder={handleCreateReminder}
        onUpdateReminder={handleUpdateReminder}
        onDeleteReminder={handleDeleteReminder}
      />

      <ReminderCategoryCard
        reminders={groupedReminders.clients}
        title="Client"
        icon={<ReduceCapacityOutlined />}
        processType={EReminderProcessType.OTHER}
        targetEntity={EReminderTargetEntity.CLIENT}
        onCreateReminder={handleCreateReminder}
        onUpdateReminder={handleUpdateReminder}
        onDeleteReminder={handleDeleteReminder}
      />

      <ReminderCategoryCard
        reminders={groupedReminders.workforce}
        title="Workforce"
        icon={<EngineeringOutlined />}
        processType={EReminderProcessType.OTHER}
        targetEntity={EReminderTargetEntity.WORKFORCE}
        onCreateReminder={handleCreateReminder}
        onUpdateReminder={handleUpdateReminder}
        onDeleteReminder={handleDeleteReminder}
      />
    </Box>
  );
}
